import { render, staticRenderFns } from "./CardJewel.vue?vue&type=template&id=39bd3140&scoped=true&"
import script from "./CardJewel.vue?vue&type=script&lang=js&"
export * from "./CardJewel.vue?vue&type=script&lang=js&"
import style0 from "./CardJewel.vue?vue&type=style&index=0&id=39bd3140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd3140",
  null
  
)

export default component.exports